import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ApplicationDashboardLayer from "../components/dashboards/ApplicationDashboardLayer";

const ApplicationDashboardPage = () => {
  return (
    <>
      <MasterLayout pageTitle="Application">
        <ApplicationDashboardLayer />
      </MasterLayout>
    </>
  );
};

export default ApplicationDashboardPage;
